import { store } from "src/store/store";
import { getThemeSource } from "src/duck/selectors";
import getIsDarkMode from "src/styling/getIsDarkMode";
import environment from "src/utils/environment";

const { appName, publicPath } = environment;
const path = window.require("path");
const fs = window.require("fs");
const { app } = window.require("@electron/remote");

function getImageSrc(imageName, { directory = "images" } = {}) {
  const appPath = app.getAppPath();
  let result;

  const relativePath = path.join(appName, directory);
  const isDarkMode = getIsDarkMode();
  const directoryPath = path.join(appPath, relativePath);

  const imagePath = path.join(directoryPath, imageName);
  if (fs.existsSync(imagePath)) {
    result = "file://" + imagePath;
  }

  if (!isDarkMode && result == null) {
    const lightImagePath = path.join(directoryPath, `light-${imageName}`);
    if (fs.existsSync(lightImagePath)) {
      result = "file://" + lightImagePath;
    }
  }

  if (isDarkMode && result == null) {
    const darkImagePath = path.join(directoryPath, `dark-${imageName}`);
    if (fs.existsSync(darkImagePath)) {
      result = "file://" + darkImagePath;
    }
  }

  return result;
}

export function hasDarkVersion(imageName, { directory = "images" } = {}) {
  const appPath = app.getAppPath();
  const relativePath = path.join(appName, directory);
  const directoryPath = path.join(appPath, relativePath);
  const darkImagePath = path.join(directoryPath, `dark-${imageName}`);

  return Boolean(fs.existsSync(darkImagePath));
}

function getBrowserImagePath(
  imageName,
  { directory = "images" } = {},
  browserProps = { useTheme: true }
) {
  const { useTheme } = browserProps;

  let isDarkMode;
  const themeSource = getThemeSource(store.getState());
  if (themeSource === "system") isDarkMode = getIsDarkMode();
  else isDarkMode = themeSource === "dark";

  const theme = useTheme ? (isDarkMode ? "dark-" : "light-") : "";
  const path = `${publicPath}/${appName}/${directory}/${theme}${imageName}`;
  return path;
}

export async function hasBrowserDarkVersion(
  imageName,
  { directory = "images" } = {}
) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = `${publicPath}/${appName}/${directory}/dark-${imageName}`;
  });
}

export default environment.isBrowser ? getBrowserImagePath : getImageSrc;
